import { useCallback, useState } from "react";
import { Button, List, Select, Row, Col, Form } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import { 
  selectSelectedBricksList, 
  selectSelectedBricks, 
  selectBrickSize, 
  selectStructure, 
  selectConfig,
  addBrick,
  removeBrick,
  changeRate,
  setBrickSize,
  setStructure,
  setHorizontalJointSize,
  setVerticalJointSize
} from "../../store/slices/configurationSlice";
import { prepareSeries } from "../../store/slices/bricksSlice";
import { SelectedStoneRow } from "./SelectedStoneRow";
import BrickPicker from "../BrickPicker";
import { BrickSeries } from "../../store/slices/bricksSlice";
import { brickSizes, structures, Joint, JointSize } from "../../constants";
import JointPicker from "../JointPicker";
import { ScaleSlider } from "../ScaleSlider";
import { WallActions } from "../WallActions";

const BrickMenu = () => {
  const dispatch = useAppDispatch();
  const selectedBricksList = useAppSelector(selectSelectedBricksList);
  const selectedBricks = useAppSelector(selectSelectedBricks);
  const brickSize = useAppSelector(selectBrickSize);
  const structure = useAppSelector(selectStructure);
  const config = useAppSelector(selectConfig);
  const [showBrickPicker, setShowBrickPicker] = useState(false);
  const toggleBrickPicker = useCallback(
    () => setShowBrickPicker(!showBrickPicker),
    [showBrickPicker]
  );

  const onBrickSelectCallback = useCallback(
    (b: BrickSeries) => {
      dispatch(addBrick(b._id));
      dispatch(prepareSeries(b._id));
      toggleBrickPicker();
    },
    [dispatch, toggleBrickPicker]
  );

  console.log(brickSize)

  let body = (
    <List className="brick-menu-list" style={{ padding: 24 }}>
      {selectedBricksList.map((b) => (
        <SelectedStoneRow
          key={b._id}
          brick={b}
          rate={selectedBricks[b._id]}
          onRateInput={(val) => {
            dispatch(changeRate({ brickId: b._id, rate: val }));
          }}
          onDelete={() => dispatch(removeBrick(b._id))}
        />
      ))}
      <List.Item>
        <Button
          type="dashed"
          size="large"
          icon={<PlusOutlined />}
          block
          onClick={toggleBrickPicker}
        >
          Kies steen
        </Button>
      </List.Item>
      <Form layout="vertical" size="middle" style={{ marginTop: 12 }}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Formaat">
              <Select
                value={brickSize}
                onChange={(val) => dispatch(setBrickSize(val))}
                options={Object.entries(brickSizes).map(([key, { width, height }]) => ({ label: `${key} (${width} x ${height})`, value: key }))}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Structuur">
              <Select
                value={structure}
                onChange={(val) => dispatch(setStructure(val))}
                options={Object.entries(structures).map(([key, s]) => ({ label: s.name, value: key }))}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Lintvoeg">
              <Select
                value={config.jointSize[Joint.Horizontal]}
                onChange={(val) => dispatch(setHorizontalJointSize(val))}
              >
                <Select.Option value={JointSize.Large}>
                  Normaal
                </Select.Option>
                <Select.Option value={JointSize.Small}>
                  Dun
                </Select.Option>
                <Select.Option value={JointSize.Glued}>
                  Verlijmd
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Stootvoeg">
              <Select
                value={config.jointSize[Joint.Vertical]}
                onChange={(val) => dispatch(setVerticalJointSize(val))}
              >
                <Select.Option value={JointSize.Large}>
                  Normaal
                </Select.Option>
                <Select.Option value={JointSize.Small}>
                  Dun
                </Select.Option>
                <Select.Option value={JointSize.Glued}>
                  Verlijmd
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label="Voegkleur" className="joint-select">
              <JointPicker />
            </Form.Item>
          </Col>
        </Row>
        <div>
          <Form.Item label="Schaal">
            <ScaleSlider />
          </Form.Item>
        </div>
        <WallActions />
      </Form>
    </List>
  );

  if (showBrickPicker) {
    body = (
      <BrickPicker
        onSelect={onBrickSelectCallback}
        onBack={toggleBrickPicker}
      />
    );
  }

  return body;
};

export default BrickMenu;
